// ==================== ESTADOS ====================
export const ESTADOS = [
  { value: "nueva", label: "Nueva", color: "bg-amber-100 text-amber-700 border-amber-200" },
  { value: "contactada", label: "Contactada", color: "bg-blue-100 text-blue-700 border-blue-200" },
  { value: "presupuesto_enviado", label: "Presupuesto Enviado", color: "bg-purple-100 text-purple-700 border-purple-200" },
  { value: "reservado_temporal", label: "Reserva Temporal", color: "bg-orange-100 text-orange-700 border-orange-200" },
  { value: "convertida", label: "Convertida", color: "bg-green-100 text-green-700 border-green-200" },
  { value: "descartada", label: "Descartada", color: "bg-red-50 text-red-600 border-red-100" },
];

// Estados a los que se puede cambiar manualmente (convertida requiere acción especial)
export const ESTADOS_CAMBIABLES = ["nueva", "contactada", "presupuesto_enviado", "reservado_temporal", "descartada"];

// Mapa estado → color (para uso rápido sin .find())
export const ESTADO_COLORS = ESTADOS.reduce((acc, e) => {
  acc[e.value] = e.color;
  return acc;
}, {});

// Mapa estado → label (para uso rápido sin .find())
export const ESTADO_LABELS = ESTADOS.reduce((acc, e) => {
  acc[e.value] = e.label;
  return acc;
}, {});

// ==================== FUENTES ====================
export const FUENTES_CONSULTA = [
  { value: "web", label: "Web" },
  { value: "email", label: "Email" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "llamada", label: "Llamada" },
  { value: "redes_sociales", label: "Redes Sociales" },
  { value: "recomendacion", label: "Recomendación" },
  { value: "bodas_net", label: "Bodas.net" },
  { value: "otro", label: "Otro" },
];

// ==================== MOTIVOS DESCARTE ====================
export const MOTIVOS_DESCARTE = [
  { value: "precio_elevado", label: "Precio elevado" },
  { value: "fecha_no_disponible", label: "Fecha no disponible" },
  { value: "servicio_no_disponible", label: "Servicio no disponible" },
  { value: "cliente_no_responde", label: "Cliente no responde" },
  { value: "evento_cancelado", label: "Evento cancelado" },
  { value: "competencia", label: "Competencia" },
  { value: "presupuesto_aceptado_otro", label: "Presupuesto aceptado por otro" },
  { value: "cliente_desconvertido", label: "Cliente desconvertido" },
  { value: "otro", label: "Otro" },
];

// ==================== TIPOS DE EVENTO ====================
export const TIPOS_EVENTO = [
  "Boda",
  "Cumpleaños",
  "Evento Corporativo",
  "Comunión",
  "Graduación",
  "Fiesta Privada",
  "Otro",
];

// ==================== CANALES DE CONTACTO ====================
export const CONTACT_METHODS = [
  { value: "llamada", label: "Llamada" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
  { value: "portal", label: "Portal" },
  { value: "otro", label: "Otro" },
];

// ==================== HELPERS ====================
export const getEstadoColor = (estado) =>
  ESTADOS.find((e) => e.value === estado)?.color || "";

export const getEstadoLabel = (estado) =>
  ESTADOS.find((e) => e.value === estado)?.label || estado;

export const getFuenteLabel = (fuente) =>
  FUENTES_CONSULTA.find((f) => f.value === fuente)?.label || fuente;

export const getMotivoDescarteLabel = (motivo) =>
  MOTIVOS_DESCARTE.find((m) => m.value === motivo)?.label || motivo;
